import { PessoaService } from './../../pessoa.service';
import { PreCadastroService } from './../../../pre-cadastro/pre-cadastro.service';
import { Dependente } from './../dependente';
import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { FormPessoaComponent } from '../../../_includes/forms/form-pessoa/form-pessoa.component';
import { SYSCONF_SIGLA } from 'src/app.api';
declare var $: any;
@Component({
	selector: 'app-dependente-create',
  	templateUrl: './dependenteCreate.component.html',
  	styleUrls: ['./dependenteCreate.component.scss']
})

export class DependenteCreateComponent implements OnInit{
	
	@ViewChild('Swal') public swal:SwalComponent; 
	public message:string = '';
	cadastroForm: FormGroup;
	dependente: Dependente;
	genero;
	estadoCivil = new Array();
	funcionarios = new Array();
	grauParentesco = new Array();
	sigla = SYSCONF_SIGLA;
	constructor(private preCadastroService: PreCadastroService, private pessoaService: PessoaService, private formBuilder: FormBuilder, private router: Router, private form: FormPessoaComponent){
		this.cadastroForm = this.formBuilder.group({
			pessoa_id: this.formBuilder.control(''),
			estrangeiro: this.formBuilder.control('N',[Validators.required]),
			passaporte: this.formBuilder.control(''),
			passaporte_dt_validade: this.formBuilder.control(''),
			cpf: this.formBuilder.control('',[Validators.required]),
			dt_nascimento: this.formBuilder.control('',[Validators.required]),
			primeiro_nome: this.formBuilder.control('',[Validators.required]),
			ultimo_nome: this.formBuilder.control('',[Validators.required]),
			nome_completo: this.formBuilder.control(''),
			apelido: this.formBuilder.control(''),
			email: this.formBuilder.control('',[Validators.email]),
			nacionalidade: this.formBuilder.control('Brasileiro',[Validators.required]),
			naturalidade: this.formBuilder.control('',[Validators.required]),
			status: this.formBuilder.control('A',[Validators.required]),
			genero_id: this.formBuilder.control('',[Validators.required]),
			grau_parentesco_id: this.formBuilder.control('',[Validators.required]),
			funcionario_id: this.formBuilder.control('',[Validators.required]),
			estado_civil_id: this.formBuilder.control(''),
			irrf: this.formBuilder.control('',[Validators.required]),
			dnv: this.formBuilder.control(''),
			cartorio_registro: this.formBuilder.control(''),
			plano_saude: this.formBuilder.control('',[Validators.required]),
			cartorio_nome: this.formBuilder.control(''),
			cartorio_livro: this.formBuilder.control(''),
			cartorio_folha: this.formBuilder.control(''),
			observacao: this.formBuilder.control(''),
			dependente_id: this.formBuilder.control(''),

			pis: this.formBuilder.control(''),
			grau_instrucao_id: this.formBuilder.control('')
		});	

		this.preCadastroService.get('pessoa/genero')
        .subscribe( (success) => {
			this.genero = success.dados;
			
		},
		(error) => {
			// this.swal.text = error.error.message;
			// this.swal.type = "error";
			// this.swal.title = "Erro!";
			// this.swal.show();
		});

		this.preCadastroService.get('pessoa/estado-civil')
        .subscribe( (success) => {
			this.estadoCivil = success.dados;
			
		},
		(error) => {
			// this.swal.text = error.error.message;
			// this.swal.type = "error";
			// this.swal.title = "Erro!";
			// this.swal.show();
		});

		this.preCadastroService.get('pessoa/grau-parentesco')
        .subscribe( (success) => {
			this.grauParentesco = success.dados;
			
		},
		(error) => {
			// this.swal.text = error.error.message;
			// this.swal.type = "error";
			// this.swal.title = "Erro!";
			// this.swal.show();
		});

		this.pessoaService.getOptions('pessoa/funcionario')
        .subscribe( (success) => {
			this.funcionarios = success.dados;
			
		},
		(error) => {
			// this.swal.text = error.error.message;
			// this.swal.type = "error";
			// this.swal.title = "Erro!";
			// this.swal.show();
		});

	}

	ngOnInit(){
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(!t.permissao.rh_dependente.includes("CRIAR"))
			this.message = 'Você não possui permissão para executar esta ação'
	}
	
	
}